module.exports = process.env.NODE_ENV === 'development' ? require('./src') : require('./build');
